import * as React from "react";
import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import styles from "../../styles/Navbar/Navbar.module.css";
import { Link, useNavigate } from "react-router-dom";
import Avatar from "@mui/material/Avatar";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import Tooltip from "@mui/material/Tooltip";
import PersonAdd from "@mui/icons-material/PersonAdd";
import Settings from "@mui/icons-material/Settings";
import Logout from "@mui/icons-material/Logout";
import axiosInstance from "../../api/axiosConfig";
import AddBusinessIcon from "@mui/icons-material/AddBusiness";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";

const NAVBAR_COLOR = "#1a3a5c";

function DrawerAppBar(props) {
  const { window } = props;
  const [professional, setProfessional] = React.useState(null);
  const navigate = useNavigate();
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [token, setToken] = React.useState("");
  const [role, setRole] = React.useState("");
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const dataPersonal = async () => {
    try {
      // El interceptor de axiosInstance adjunta el token automáticamente
      const response = await axiosInstance.get("/api/datapersonal");
      setProfessional(response.data);
      setRole(response.data.role);
    } catch (error) {
      console.error("Error al obtener los detalles:", error);
    }
  };

  React.useEffect(() => {
    const token = localStorage.getItem("token");
    setToken(token);
  }, []);

  React.useEffect(() => {
    if (token) {
      dataPersonal();
    }
  }, [token]);

  const handleLogout = async () => {
    try {
      await localStorage.removeItem("token");
      navigate("/login");
    } catch (error) {
      console.log(error);
    }
  };

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  const getPanelRoute = () => {
    // TODO: restaurar lógica por rol cuando el panel esté listo
    if (role === "profesional") return "/panel/consultas/disponibles";
    if (role === "sede") return "/panel/sede";
    return "/mis-consultas";
  };

  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{ textAlign: "center" }}>
      <Typography variant="h6" sx={{ background: NAVBAR_COLOR, p: 2 }}>
        <Link to="/" className={[styles.optionsNavbar]}>
          <img
            src={require("../../assets/Images/logo.png")}
            alt="Logo"
            className={styles.logoMobile}
          />
        </Link>
      </Typography>
      <Divider />
      <List>
        <Link to="/" style={{ textDecoration: "none", color: "black" }}>
          <ListItem disablePadding>
            <ListItemButton>
              <ListItemText primary={"Buscar especialista"} />
            </ListItemButton>
          </ListItem>
        </Link>
        <Link to="/registrar-empresa" style={{ textDecoration: "none", color: "black" }}>
          <ListItem disablePadding>
            <ListItemButton>
              <ListItemText primary={"Para Empresas"} />
            </ListItemButton>
          </ListItem>
        </Link>
        <Link to="/registrar-sede" style={{ textDecoration: "none", color: "black" }}>
          <ListItem disablePadding>
            <ListItemButton>
              <ListItemText primary={"Para Clínicas"} />
            </ListItemButton>
          </ListItem>
        </Link>
        <Link to="/registrar-profesional" style={{ textDecoration: "none", color: "black" }}>
          <ListItem disablePadding>
            <ListItemButton>
              <ListItemText primary={"Para Profesionales"} />
            </ListItemButton>
          </ListItem>
        </Link>
        {token && (
          <Link to={getPanelRoute()} style={{ textDecoration: "none", color: "black" }}>
            <ListItem disablePadding>
              <ListItemButton>
                <ListItemText primary={"Mi panel"} />
              </ListItemButton>
            </ListItem>
          </Link>
        )}
        {!token && (
          <>
            <Link to="/login" style={{ textDecoration: "none", color: "black" }}>
              <ListItem disablePadding>
                <ListItemButton>
                  <ListItemText primary={"Iniciar Sesión"} />
                </ListItemButton>
              </ListItem>
            </Link>
            <Link to="/registrar-usuario" style={{ textDecoration: "none", color: "black" }}>
              <ListItem disablePadding>
                <ListItemButton>
                  <ListItemText primary={"Registrarse"} />
                </ListItemButton>
              </ListItem>
            </Link>
          </>
        )}
      </List>
    </Box>
  );

  const container = window !== undefined ? () => window().document.body : undefined;

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppBar component="nav" sx={{ backgroundColor: NAVBAR_COLOR }}>
        <Toolbar sx={{ position: "relative" }}>
          {/* Botón hamburguesa para móvil */}
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: "none" } }}
          >
            <MenuIcon />
          </IconButton>

          {/* Logo - izquierda */}
          <Box component="div" sx={{ mr: 4 }}>
            <a href="/" className={styles.optionsNavbar}>
              <img
                src={require("../../assets/Images/logo.png")}
                alt="Logo"
                className={styles.logo}
              />
            </a>
          </Box>

          {/* Links centrales - absolutamente centrados */}
          <Box
            sx={{
              position: "absolute",
              left: "50%",
              transform: "translateX(-50%)",
              display: { xs: "none", sm: "flex" },
              gap: "2em",
              alignItems: "center",
            }}
          >
            <Link to="/" className={styles.optionsNavbar}>
              Buscar especialista
            </Link>
            <Link to="/registrar-empresa" className={styles.optionsNavbar}>
              Para Empresas
            </Link>
            <Link to="/registrar-sede" className={styles.optionsNavbar}>
              Para Clínicas
            </Link>
            <Link to="/registrar-profesional" className={styles.optionsNavbar}>
              Para Profesionales
            </Link>
            {token && (
              <>
                <Divider
                  orientation="vertical"
                  flexItem
                  sx={{ borderColor: "rgba(255,255,255,0.35)", mx: 0.5 }}
                />
                <Link to={getPanelRoute()} className={styles.optionsNavbar}>
                  Mi panel
                </Link>
              </>
            )}
          </Box>

          {/* Spacer para empujar botones a la derecha */}
          <Box sx={{ flexGrow: 1 }} />

          {/* Derecha: botones o avatar */}
          {!token ? (
            <Box
              sx={{
                display: { xs: "none", sm: "flex" },
                gap: "1em",
                alignItems: "center",
              }}
            >
              <Link to="/login" className={styles.btnLogin}>
                Iniciar Sesión
              </Link>
              <Link to="/registrar-usuario" className={styles.btnRegister}>
                Registrarse
              </Link>
            </Box>
          ) : (
            <>
              <Box sx={{ display: { xs: "none", sm: "flex" }, alignItems: "center" }}>
                <Tooltip title="Account settings">
                  <IconButton
                    onClick={handleClick}
                    size="small"
                    sx={{ ml: 2 }}
                    aria-controls={open ? "account-menu" : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? "true" : undefined}
                  >
                    <Avatar
                      src={professional && professional.image}
                      sx={{
                        backgroundColor: professional && professional.backgroundColor,
                        width: 50,
                        height: 50,
                      }}
                    >
                      {professional && professional.image
                        ? null
                        : professional && professional.name[0]}
                    </Avatar>
                  </IconButton>
                </Tooltip>
              </Box>
              <Menu
                anchorEl={anchorEl}
                id="account-menu"
                open={open}
                onClose={handleClose}
                onClick={handleClose}
                slotProps={{
                  paper: {
                    elevation: 0,
                    sx: {
                      overflow: "visible",
                      filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                      mt: 1.5,
                      "& .MuiAvatar-root": {
                        width: 32,
                        height: 32,
                        ml: -0.5,
                        mr: 1,
                      },
                      "&::before": {
                        content: '""',
                        display: "block",
                        position: "absolute",
                        top: 0,
                        right: 14,
                        width: 10,
                        height: 10,
                        bgcolor: "background.paper",
                        transform: "translateY(-50%) rotate(45deg)",
                        zIndex: 0,
                      },
                    },
                  },
                }}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              >
                {role === "personal" && (
                  <>
                    <Link to={"/mi-perfil"} style={{ textDecoration: "none", color: "#000" }}>
                      <MenuItem onClick={handleClose}>
                        <ListItemIcon>
                          <PersonAdd fontSize="small" />
                        </ListItemIcon>
                        Mi Perfil
                      </MenuItem>
                    </Link>
                    <Link to={"/mis-consultas"} style={{ textDecoration: "none", color: "#000" }}>
                      <MenuItem onClick={handleClose}>
                        <ListItemIcon>
                          <VerifiedUserIcon fontSize="small" />
                        </ListItemIcon>
                        Mis consultas
                      </MenuItem>
                    </Link>
                  </>
                )}
                {role === "profesional" && (
                  <>
                    <Link
                      to={"/mi-perfil/profesional"}
                      style={{ textDecoration: "none", color: "#000" }}
                    >
                      <MenuItem onClick={handleClose}>
                        <ListItemIcon>
                          <PersonAdd fontSize="small" />
                        </ListItemIcon>
                        Mi Perfil
                      </MenuItem>
                    </Link>
                    <a
                      href={"/panel/consultas/disponibles"}
                      style={{ textDecoration: "none", color: "#000" }}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <MenuItem onClick={handleClose}>
                        <ListItemIcon>
                          <AddBusinessIcon fontSize="small" />
                        </ListItemIcon>
                        Mi consultorio
                      </MenuItem>
                    </a>
                  </>
                )}
                {role === "sede" && (
                  <Link to={"/panel/sede"} style={{ textDecoration: "none", color: "#000" }}>
                    <MenuItem onClick={handleClose}>
                      <ListItemIcon>
                        <Settings fontSize="small" />
                      </ListItemIcon>
                      Turnos reservados sede
                    </MenuItem>
                  </Link>
                )}
                <MenuItem onClick={handleLogout}>
                  <ListItemIcon>
                    <Logout fontSize="small" />
                  </ListItemIcon>
                  Cerrar sesión
                </MenuItem>
              </Menu>
            </>
          )}
        </Toolbar>
      </AppBar>
      <nav>
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true,
          }}
          sx={{
            display: { xs: "block", sm: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: 240,
            },
          }}
        >
          {drawer}
        </Drawer>
      </nav>
    </Box>
  );
}

DrawerAppBar.propTypes = {
  window: PropTypes.func,
};

export default DrawerAppBar;
